import { updateBeamUrl } from '@utils/updateBeamUrl/updateBeamUrl';
import { IDocumentFileApiModel } from './File.model';
import { IManufacturerApiModel, IManufacturer } from './Manufacturer.model';
import { IProduct, IProductApiModel } from './Product.model';
import { IDocumentUserApiModel } from './User.model';

export interface IDocument {
  id: string;
  label: string;
  uri: string | null;
  description?: string | null;
  ownerStudioId?: string | null;
  manufacturerId?: string;
  isGlobal: boolean | null;
  favorite: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface IDocumentTableApiModel {
  id: string;
  label: string;
  fileId: string;
  createdAt: string;
  updatedAt: string;
  type: string | null;
  uri: string | null;

  isGlobal: boolean | null;
  ownerStudioId: string | null;
  releaseDate: string | null;
  description: string | null;
  dataHash: string | null;
  source: string | null;

  associatedWith: AssociatedWith.manufacturer | AssociatedWith.product;
  manufacturers?: [IManufacturerApiModel];
  products?: [IProductApiModel];

  // Tbd:
  addedByUser: [IDocumentUserApiModel];
  file: IDocumentFileApiModel | null;
}
export enum DocumentAddedBy {
  beam = 'beam',
  internal = 'internal',
}
export enum AssociatedWith {
  product = 'product',
  manufacturer = 'manufacturer',
  global = 'global',
}
export interface IDocumentTable {
  id: string;
  label: string;
  fileId: string;
  createdAt: Date;
  updatedAt: Date;
  type: string | null;
  uri: string | null;
  isGlobal: boolean | null;
  ownerStudioId: string | null;
  releaseDate: Date | null;
  description: string | null;
  dataHash: string | null;
  source: string | null;
  manufacturer: IManufacturer | undefined;
  product: IProduct | undefined;
  // Derived, for field config

  addedBy: DocumentAddedBy;

  associatedWith: AssociatedWith;
  associatedWithName: string;
  associatedWithSource: string;
  addedByName: string;
  manufacturerId: string | undefined;
  productManufacturerId: string | undefined;
  // Tbd:
  addedByUser: IDocumentUserApiModel | undefined;
}

export interface IDocumentApiModel {
  id: string;
  label: string;
  uri?: string | null;
  description?: string | null;
  ownerStudioId?: string | null;
  isGlobal: boolean;
  file?: {
    uri: string;
  };
  documentStudios?: Array<{ favorite: boolean }>;
  documentManufacturers?: Array<{ id: string }>;
  createdAt: string;
  updatedAt: string;
}

export default class Document implements IDocument {
  public readonly id: string;

  public readonly label: string;

  public readonly favorite: boolean;

  public readonly uri: string | null;

  public readonly description?: string | null;

  public readonly ownerStudioId?: string | null;

  public readonly manufacturerId?: string;

  public readonly isGlobal: boolean;

  public readonly products?: IProduct;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    label: string,
    favorite: boolean,
    createdAt: Date,
    updatedAt: Date,
    isGlobal: boolean,
    uri: string | null,
    ownerStudioId?: string | null,
    description?: string | null,
    manufacturerId?: string,
  ) {
    this.id = id;
    this.label = label;
    this.uri = uri;
    this.favorite = favorite;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.isGlobal = isGlobal;
    this.ownerStudioId = ownerStudioId;
    this.description = description;
    this.manufacturerId = manufacturerId;
  }

  static fromApiModel(apiModel: IDocumentApiModel) {
    const {
      id,
      label,
      ownerStudioId,
      description,
      documentStudios,
      isGlobal,
      documentManufacturers,
    } = apiModel;

    const favorite = documentStudios?.[0]?.favorite || false;
    const manufacturerId = documentManufacturers?.[0]?.id;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    // eslint-disable-next-line no-nested-ternary
    const uri = apiModel.uri
      ? updateBeamUrl(apiModel.uri)
      : apiModel.file
      ? updateBeamUrl(apiModel.file.uri)
      : null;

    return new Document(
      id,
      label,
      favorite,
      createdAt,
      updatedAt,
      isGlobal,
      uri,
      ownerStudioId,
      description,
      manufacturerId,
    );
  }

  static arrayFromApiModel(arrayApiModel: IDocumentApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }
}
